<template>
  <el-dialog
    class="comp-container"
    :visible.sync="endClassVisible"
    width="30%"
    top="30vh"
    custom-class="comfirm-remove-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <div class="tips">异常，暂无屏幕分享权限</div>

    <div class="footer">
      <el-button @click="handleClickCancel"> 取消 </el-button>
      <el-button type="primary" @click="handleClickSet"> 去设置 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      endClassVisible: false,
      timer: null,
      seconds: 4,
      initSeconds: 4,
    };
  },
  computed: {
    ...mapState("live", ["liveService", "imService"]),
  },
  methods: {
    handleClickSet() {
      window.ipcRenderer.send("open-permission-setting", {
        curtMediaType: "screen",
      });
    },
    handleClickCancel() {
      this.endClassVisible = false;
    },
    open() {
      this.endClassVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #a1a1aa;

      text-align: center;
      .tips {
        max-width: 300px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
      .el-checkbox {
        margin-top: 8px;
        .el-checkbox__input.is-checked {
          .el-checkbox__inner {
            background: #165dff;
            border-color: #165dff;
          }
        }
        .el-checkbox__inner {
          border-color: #165dff !important;
          &:hover {
            border-color: #165dff;
          }
        }
        .el-checkbox__label {
          color: #a1a1aa;
        }
      }
      .footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
            &:focus {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
